// TODO: This input type only has tabular for Edit theme? Feels incomplete. Investigate later if this is actually used.

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-ExistingDisabledByDefault',
			DefaultInputExtensions: [ 'InputValidation', 'ExistingDisabledByDefault' ],
			Template: /*HTML-Partial*/`
			<!-- InputType ExistingDisabledByDefault {~D:Record.Hash~} {~D:Record.DataType~} -->
			<p class="control control-status">
				<span class="control-status-icon"></span>
				<input
					id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="text"
					class="input"
					{~Required:Record~}
					{~Disabled:Record~}
					placeholder="{~Placeholder:Record~}"
					{~D:Record.Macro.HTMLName~}
					{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-ExistingDisabledByDefault',
			Template: /*HTML-Partial*/`
					value=""
				/>
			</p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		/* NOTE: Remove me and add your own templates here for the Read theme */
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		/* NOTE: Remove me and add your own templates here for the Print theme */
	],
};

module.exports = _TemplatesGroupedByTheme;
